import { Authentication, AuthorizationSteps } from './authSlice';

export type EmailStepAction = 'none' | 'gotoNext' | 'gotoChallenge' | 'logout';

// Decides what the email step does with the current auth state. A finished
// login from the email field moves the wizard on. A login from the `id` query
// param skips the email field only when it needs a code, since the code goes to
// the account's owner; an already authorized one is reset like any other state
// that means the user came back to this step, so they log out and enter an email.
export const getEmailStepAction = ({
  auth,
  submitting,
  hasAdvanced,
}: {
  auth: Pick<Authentication, 'authStep' | 'isProcessing' | 'pendingUserIdAuth'>;
  submitting: boolean;
  hasAdvanced: boolean;
}): EmailStepAction => {
  if (auth.isProcessing || hasAdvanced) {
    return 'none';
  }
  if (submitting) {
    if (auth.authStep === AuthorizationSteps.Authorized) {
      return 'gotoNext';
    }
    if (auth.authStep === AuthorizationSteps.Challenged) {
      return 'gotoChallenge';
    }
    return 'none';
  }
  if (
    auth.pendingUserIdAuth &&
    auth.authStep === AuthorizationSteps.Challenged
  ) {
    return 'gotoChallenge';
  }
  if (auth.authStep !== AuthorizationSteps.Unauthorized) {
    return 'logout';
  }
  return 'none';
};
